// utils/loadingUtils.js
import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

export const renderLoadingOrEmptyState = (data, filters, tempFilters) => {
  if (
    !data ||
    !filters ||
    !tempFilters ||
    (data && Object.values(data).every((value) => value === null))
  ) {
    return (
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {data && Object.values(data).every((value) => value === null) ? (
          <Typography variant="body1"></Typography>
        ) : (
          <CircularProgress />
        )}
      </Box>
    );
  }
  return null;
};
